import { SelectOption } from '@globaleris/ui.library'
import moment from 'moment'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import {
  ComunicationMailModel,
  ComunicationModel,
  apiFetchComunicationsRequest
} from '../../model/comunication/comunications'

export const apiFetchComunications = async (
  request: apiFetchComunicationsRequest
): Promise<ComunicationModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  let query = ''

  const startDateString = request.startDate ? moment(request.startDate).format('YYYY-MM-DD') : ''
  const endDateString = request.endDate ? moment(request.endDate).format('YYYY-MM-DD') : ''

  if (request?.subjectID) {
    query = `subjectID=${request.subjectID}&`
  }

  if (request?.startDate) {
    query += `startDate=${startDateString}&`
  }

  if (request?.endDate) {
    query += `&endDate=${endDateString}`
  }

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Comunications?${query}`).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchComunicationDetails = async (
  comunicationId: number
): Promise<ComunicationMailModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Comunications/${comunicationId}`).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchMasterComunicationsOptions = async (): Promise<SelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Comunications/GetMasterComunicationsOptions`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPostComunication = async (
  subjectId: number,
  masterComunicationId: number,
  contractId: number
): Promise<ComunicationMailModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Comunications`, {
    subjectId,
    masterComunicationId,
    contractId
  }).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}
